import "bootstrap";
import htmx from "htmx.org";
window.htmx = htmx;

import Vue from "vue";
import * as Sentry from "@sentry/vue";

if (window.SENTRY_CONFIG && window.SENTRY_CONFIG.dsn) {
    Sentry.init({
        Vue: Vue,
        dsn: window.SENTRY_CONFIG.dsn,
        release: window.SENTRY_CONFIG.release,
        environment: window.SENTRY_CONFIG.environment,
        sendDefaultPii: true,
    });

    if (window.SENTRY_CONFIG.user) {
        Sentry.setUser({
            id: window.SENTRY_CONFIG.user.id,
            email: window.SENTRY_CONFIG.user.email,
            username: window.SENTRY_CONFIG.user.username,
        });
    }
}

require(["./vue_app"]);

// export jQuery to global scope; this is needed for django-session-security
const jquery = require("jquery");
global.$ = jquery;
global.jQuery = global.$;
